export const appData = {
  orgFields: {
    name: {
      key: 'name',
      label: 'Org name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    logoUrl: {
      key: 'logoUrl',
      label: 'Org logo',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Required' },
    },
    phone: {
      key: 'phone',
      label: 'Contact Phone',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    email: {
      key: 'email',
      label: 'Contact Email',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
      email: { value: true, err: 'Provide a valid email' }
    }
  },
  orgColTitles: [
    {
      text: 'Name',
      key: 'name',
      type: 'text'
    },
    {
      text: 'Logo',
      key: 'logoUrl',
      type: 'image'
    }
  ],
  popOverFields: [
    {
      key: 'edit',
      title: 'Edit'
    },
    {
      key: 'delete',
      title: 'Delete'
    }
  ],
  placeTilePopOverFields: [
    {
      key: 'downloadReport',
      title: 'Download Report'
    },
    {
      key: 'edit',
      title: 'Edit'
    },
    {
      key: 'delete',
      title: 'Delete'
    }
  ],
  regularPopOverFields: [
    {
      key: 'viewInfo',
      title: 'View Info'
    },
    {
      key: 'downloadReport',
      title: 'Download Report'
    }
  ],
  userColTitles: [
    {
      type: 'multiple',
      items: [
        {
          text: 'NAME',
          key: 'name',
          type: 'text'
        },
        {
          text: 'E-MAIL ID',
          key: 'email',
          type: 'text'
        },
        {
          text: 'ROLE',
          key: 'role',
          type: 'list'
        }
      ]
    },

  ],
  userColMobileTitles: [
    {
      text: 'User Details',
      key: 'userDetails',
      type: 'text'
    },
  ],
  userColDesktopViewTitles: [
    {
      text: 'E-MAIL ID',
      key: 'email',
      type: 'text'
    },
    {
      text: 'ROLE',
      key: 'role',
      type: 'list'
    },
    {
      text: 'NAME',
      key: 'name',
      type: 'text'
    },
  ],
  userFieldEmail: {
    email: {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    }
  },
  userFields: {
    email: {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      placement: 'left',
      disabled: true,
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    },
    role: {
      key: 'role',
      label: 'Select Role',
      placement: 'right',
      type: 'checkbox',
      required: { value: true, err: 'Provide a role' },
      options: [
        {
          name: 'ADMIN',
          key: 'ADMIN',
        },
        {
          name: 'REGULAR',
          key: 'REGULAR',
        },
        {
          name: 'RESIDENT',
          key: 'RESIDENT',
        }
      ],
    },
    cred: {
      key: 'cred',
      label: 'New Password (required only for password change)',
      type: 'input_text',
      inputHide: true,
      placement: 'full',
      required: { value: false, err: 'Provide a password' },
    },
    name: {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Provide your name' },
    },
    phone: {
      key: 'phone',
      label: 'Phone',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    vehicleNumbers: {
      key: 'vehicleNumbers',
      label: 'Vehicle Numbers',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Provide vechicle number' },
    },
  },
  adminUserFields: {
    email: {
      key: 'email',
      label: 'Email Address',
      type: 'input_text',
      disabled: true,
      placement: 'left',
      required: { value: true, err: 'Provide your email' },
      email: { value: true, err: 'Provide a valid email' }
    },
    name: {
      key: 'name',
      label: 'Name',
      type: 'input_text',
      placement: 'right',
      required: { value: true, err: 'Provide your name' },
    },
    phone: {
      key: 'phone',
      label: 'Phone',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Provide phone number' },
      phone: { value: true, err: 'Provide a valid phone' },
    },
    cred: {
      key: 'cred',
      label: 'Password (required only for password change)',
      type: 'input_text',
      inputHide: true,
      placement: 'right',
      required: { value: false, err: 'Provide a password' },
    },
  },
  placeFields: {
    name: {
      key: 'name',
      label: 'Place Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    type: {
      key: 'type',
      label: 'Select place type',
      type: 'select_single',
      placement: 'right',
      required: { value: true, err: 'Required' },
      options: []
    },
    lat: {
      key: 'lat',
      label: 'Location Latitude',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
    },
    long: {
      key: 'long',
      label: 'Location longitude',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Required' },
    },
    logoUrl: {
      key: 'logoUrl',
      label: 'Place logo link',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Required' },
    }
  },
  camFields: {
    name: {
      key: 'name',
      label: 'Camera Name',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    type: {
      key: 'type',
      label: 'Select cam type',
      type: 'select_single',
      placement: 'right',
      required: { value: true, err: 'Required' },
      options: []
    },
    streamContentWidth: {
      key: 'streamContentWidth',
      label: 'Width (pixel)',
      type: 'input_text',
      placement: 'left',
      required: { value: true, err: 'Required' },
    },
    streamContentHeight: {
      key: 'streamContentHeight',
      label: 'Height (pixel)',
      type: 'input_text',
      placement: 'right',
      required: { value: true, err: 'Required' },
    },
    urlVideo: {
      key: 'urlVideo',
      label: 'Camera Video URL',
      type: 'input_text',
      placement: 'left',
      required: { value: false, err: 'Required' },
    },
    flags: {
      key: 'flags',
      label: 'Camera flags',
      type: 'input_text',
      placement: 'right',
      required: { value: false, err: 'Required' },
    },
    urlJpeg: {
      key: 'urlJpeg',
      label: 'Camera Image URL',
      type: 'input_text',
      placement: 'full',
      required: { value: false, err: 'Required' },
    },
  },
  reportFields: {
    selectCam: {
      key: 'selectedCamIds',
      type: 'checkbox',
      options: []
    },
    eventFields: {
      key: 'eventFields',
      label: 'Event fields',
      labelValue: 'eventFieldLabel',
      type: 'text',
      options: []
    },
    eventImages: {
      key: 'eventImages',
      label: 'Event Images',
      type: 'text',
      options: []
    },
    fromDateTs: {
      key: 'fromDateTs',
      label: 'From',
      type: 'text',
    },
    toDateTs: {
      key: 'toDateTs',
      label: 'To',
      type: 'text'
    }
  }
}


// WEBPACK FOOTER //
// ./src/data/AppData.js